import { useState} from "react";


function FlatInsurance(props){
       
    const flatInsurance = props.flatInsuranceCost * props.creditValue;
    
    return flatInsurance.toFixed(2);
}


function FlatInsuranceTotal(props){

    const flatInsuranceTotal = props.loanPeriod/12 * props.flatInsuranceCost * props.creditValue;

    return flatInsuranceTotal;

}
    
function LifeInsurance(props){

    const lifeInsurance2 = props.creditValue * props.lifeInsurance;

    return lifeInsurance2.toFixed(2);
}


function LifeInsuranceTotal(props){

  let lifeInsurance = props.lifeInsurance;
  let creditValue = props.creditValue;
  let loanPeriod = props.loanPeriod;
  let interestRate = props.interestRate/1200;
  let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
  let creditValue2 = creditValue;
  let insurancePeriod = props.insurancePeriod;
  let lifeInsuranceTotal = 0;
  let lifeInsurancePKO1 = 0.0033276 * creditValue;
  let lifeInsurancePKO2 = 0.0002773;
  
  if(props.id === 53||props.id === 9 || props.id === 44){
    for (let i = 0; i < insurancePeriod; i++) {
        creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
        lifeInsuranceTotal = lifeInsuranceTotal + (creditValue2 * lifeInsurancePKO2);
    }
lifeInsuranceTotal = lifeInsuranceTotal - lifeInsurancePKO1
   
   console.log(lifeInsuranceTotal)
    return lifeInsuranceTotal.toFixed(2) 
  }

  


  for (let i = 0; i < insurancePeriod; i++) {
     creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
     lifeInsuranceTotal = lifeInsuranceTotal + (creditValue2 * lifeInsurance);
 }
  if(props.jakaSkładka === "Jednorazowo") return props.creditValue * props.lifeInsurance
  if(props.jakaSkładka === "Brak") return "";

    return lifeInsuranceTotal.toFixed(2);

}   

function PkoBPBK2Insurance(props){
    let lifeInsurance = 0.0033276;
    let lifeInsurance2 = - 0.0002773
    let creditValue = props.creditValue;
    let loanPeriod = props.loanPeriod;
    let interestRate = props.interestRate/1200;
    let paymentRate2 = (creditValue*interestRate*Math.pow(1 + interestRate, loanPeriod)) / (Math.pow(1 + interestRate, loanPeriod) - 1);
    let creditValue2 = creditValue;
    let creditValue3 = creditValue;
    let insurancePeriod = props.insurancePeriod;
    
    let lifeInsuranceTotal2 = 0;
    


    for (let i = 0; i < insurancePeriod; i++) {
       creditValue2 = (creditValue2 - (paymentRate2 - ((creditValue2 * interestRate))));
       lifeInsuranceTotal2 = lifeInsuranceTotal2 + (creditValue2 * lifeInsurance2);
   }
 
    
   let pkobpBK2Insurance = (lifeInsurance *creditValue) + lifeInsuranceTotal2;

console.log(lifeInsurance, lifeInsuranceTotal2, lifeInsuranceTotal2)
    return lifeInsurance
}
    


export default FlatInsurance;
export {LifeInsurance}
export {FlatInsuranceTotal}
export {LifeInsuranceTotal}
export {PkoBPBK2Insurance}